import React from 'react'
import jump from 'jump.js'

import { PageLink } from 'src/components/link'

const handleJump = () => {
  const jumpy = document.querySelector('.js-content')
  jump(jumpy, {
    offset: -76
  })
}

export const Footer = () => {
  const date = new Date()
  return (
    <React.Fragment>
      <div className='bcb cw bt1'>
        <div className='marquee py1'>
          <div className='marquee__inner'>
            <span className='outline a-black caps'> GOD ANSWERS CALLS. WE WON’T.</span>
            <span className='outline a-black caps'> GOD ANSWERS CALLS. WE WON’T.</span>
          </div>
        </div>
      </div>
      <div className='bcb cw bt1'>

        <div className='container--xl mxa s-f-desktop x footer__flex px1 outer f jcb aist'>
          <div className='c30 py1'>
            <p className='caps mt0 pt0'>Location<br />199 Cook st<br />Brooklyn, New York<br />11206</p>
            <p className='caps s1 mb0 pb0 cw'>Email<br /><a href='mailto:hello@usby.us'>hello@usby.us</a></p>
          </div>
          <div className='al c30 bl1 p1 footer__bump'>
            <PageLink className='caps block s1 footer__about cw' to='/about'>About</PageLink><br />
            <PageLink className='caps block s1 cw' to='/'>Full Catalog</PageLink>
            <PageLink className='caps block s1 cw' to='/collection/art'>Art</PageLink>
            <PageLink className='caps block s1 cw' to='/collection/clothing'>clothing</PageLink>
            <PageLink className='caps block s1 cw' to='/collection/accessories'>Accessories</PageLink>
            <PageLink className='caps block s1 cw' to='/collection/publications'>Publications</PageLink>
          </div>
          <div className='al c30 bl1 p1 footer__bump'>
            <a className='caps block s1 cw' href='https://instagram.com/theusbyus' target='_blank' rel='noopener nofollow'>Instagram</a>
          </div>
        </div>
        <div className='container--xl mxa s-mobile x p1 outer f jcb ais'>
          <div>
            <p className='caps mt0 footer__mobile-bump pt0'>Location<br />199 Cook st<br />Brooklyn, NY<br />11206</p>
            <p className='caps s1 mb0 pb0 cw'>Email<br /><a href='mailto:hello@usby.us'>hello@usby.us</a></p>
          </div>
          <div className='ar'>
            <PageLink className='caps block s1 cw' to='/about'>About</PageLink>
            <PageLink className='caps block s1 cw' to='/'>Full Catalog</PageLink>
            <PageLink className='caps block s1 cw' to='/collection/art'>Art</PageLink>
            <PageLink className='caps block s1 cw' to='/collection/clothing'>clothing</PageLink>
            <PageLink className='caps block s1 cw' to='/collection/accessories'>Accessories</PageLink>
            <PageLink className='caps block s1 cw' to='/collection/publications'>Publications</PageLink>
            <a className='caps block s1 cw' href='https://instagram.com/theusbyus' target='_blank' rel='noopener nofollow'>Instagram</a>
          </div>
        </div>
      </div>
      <div className='bcb cw bt1'>
        <div className='container--xl mxa x p1 outer'>
          <div className='f x jcb ais'>
            <span className='s1'>&copy; USBYUS</span>
            <span className='s1'>{date.getFullYear()}</span>
            <button type='button' onClick={() => handleJump()} className='s-desktop s1 caps button h-underline'>Back to Top</button>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}